export default `
§ page.welcome.step1: 프로젝트 루트에서 명령을 실행합니다
§ page.welcome.step3: 드래그
§ page.welcome.step4: 그리고 파일 로그를 삭제합니다.이 페이지로
§ page.welcome.description: 힘내는 파일 로그를 만들 것입니다.- 네 여기에는 보고서 작성을 위한 데이터가 포함되어 있습니다. 또는 보고서가 필요하지 않은 경우 짧은 로그가 필요합니다. 직원 통계를 결합하기 위해 프로젝트의 루트에[.메일 맵|<url>/문서/자식 메일 맵]파일을 만듭니다.
§ page.welcome.warning1: 서비스*저장하지 않습니다*및*전송하지 않습니다*귀하의 데이터. 모든 계산은 컴퓨터에 바로 브라우저에서 로컬로 수행됩니다.
§ page.welcome.warning2: 서비스*는 프로젝트에 대한 통계*를 수집하지 않습니다. 인터넷을 끄고 트래픽을 확인하고 로컬 빌드를 구축 할 수도 있습니다.
§ page.common.words.title: 단어에 대한 통계
§ page.common.words.description: 가장 인기있는 단어입니다. 그것은 발생$1 시대.
§ page.common.commits.title: 일별 커밋 수
§ page.common.commits.description: ($1)커밋 수에 따라 가장 생산적인 날.
§ page.common.commits.title2: $1 커밋:$2
§ page.common.filter.allUsers: 그것은 중요하지 않습니다
§ page.print.modal.title: 우리는 무엇을 인쇄하고 있습니까?
§ page.print.modal.page: 현재 페이지
§ page.print.modal.type: 현재 섹션
§ page.print.modal.all: 모든 통계
§ page.print.modal.cancel: 취소
§ page.print.tableOfContents: 내용 표
§ page.print.title: 자식 저장소에 대한 보고서
§ page.print.sub_title: "$1"
§ page.print.description: 보고서의 데이터는 커밋 기록에서 얻었습니다.
§ page.team.author.statusChart.title: 현재 상태
§ page.team.author.daysChart.title: 근무 시간
§ page.team.author.daysChart.item: 일
§ page.team.author.days.half: 반 년
§ page.team.author.days.one: 1 년
§ page.team.author.days.15: 한 반
§ page.team.author.days.two: 2 년
§ page.team.author.days.more: 더 보기
§ page.team.author.title: 세부 정보
§ page.team.author.description1: *통계의 일부*(작업 속도,지출된 돈 등))*는 프로젝트에서 일시적인 역할이기 때문에"보조"유형*을 가진 직원에 포함되지 않습니다. 우리는 그들이 프로젝트에 영향을 미치지 않는다고 가정하고,그들의 편집은 총 작업량의 배경에 대해 무시할 수 있습니다.
§ page.team.author.description2: *기본 정렬*작업 및 그룹 수(현재,해고,직원 지원)로 정렬됩니다.
§ page.team.author.status: 상태
§ page.team.author.company: 회사소개
§ page.team.author.firstCommit: 첫 번째 커밋
§ page.team.author.lastCommit: 마지막
§ page.team.author.daysAll: 그냥 일
§ page.team.author.types: 작업 유형
§ page.team.author.commits: 커밋
§ page.team.author.commitsSmall: 커밋
§ page.team.author.tasks: 작업
§ page.team.author.tasksSmall: 작업
§ page.team.author.workedLosses: 커밋이 있는 날과 없는 날
§ page.team.author.worked: 일
§ page.team.author.losses: 커밋 없는 일
§ page.team.author.days: 일
§ page.team.author.daysForTask: 일 당
§ page.team.author.scopes: 기능 작업
§ page.team.author.moneyAll: 수신
§ page.team.author.moneyWorked: 밖으로 일
§ page.team.author.moneyLosses: 초과 지불
§ page.team.author.type.work: 작동 중
§ page.team.author.type.dismissed: § page.team.author.type.dismissed: уволен
§ page.team.author.type.staff: 조수가 해고됐어
§ page.team.hours.title: 각 요일 동안의 커밋 배포
§ page.team.month.title: 프로젝트 작업 일정
§ page.team.month.first: (첫 근무일)
§ page.team.month.last: (마지막 작업 일)
§ page.team.scope.title: 기능 통계
§ page.team.scope.scope: 특징
§ page.team.scope.days: 노예 일
§ page.team.scope.authorsDays: 남자 일
§ page.team.scope.tasks: 작업
§ page.team.scope.commits: 커밋
§ page.team.scope.commitsSmall: 커밋
§ page.team.scope.types: 작업 유형
§ page.team.scope.authors: 개인 기여
§ page.team.scope.cost: 비용
§ page.team.type.title: 작업 유형별 통계
§ page.team.type.description: *개인 기여*는 수정 된 라인 또는 파일의 볼륨이 아닌 커밋 수에 의해 계산됩니다. 따라서"파일 분석"섹션도 살펴보고 변경 사항의 규모를 평가해야 합니다.
§ page.team.type.type: 작업 유형
§ page.team.type.unknown: 알 수 없는
§ page.team.type.tasks: 작업
§ page.team.type.tasksSmall: 작업
§ page.team.type.days: 일
§ page.team.type.daysSmall: 일
§ page.team.type.authorsDays: 남자 일
§ page.team.type.commits: 커밋
§ page.team.type.authors: 개인 기여
§ page.team.total.titleA: 작업 범위
§ page.team.total.titleB: 비용
§ page.team.total.daysWorked.title: 인간의 날
§ page.team.total.daysWorked.description: 약속이 이루어진 날만 고려됩니다.
§ page.team.total.commits.title: § page.team.total.commits.title: коммитов
§ page.team.total.commits.description: 삭제된 분기는 계산되지 않습니다
§ page.team.total.daysLosses.title: 커밋 없는 일
§ page.team.total.daysLosses.description: 모든 일 빼기:휴일,주말,휴가,커밋이있는 일
§ page.team.total.employment.title: 작업/종료
§ page.team.total.employment.description: 직원이 한 달 이내에 단일 커밋을하지 않은 경우 그는 해고 된 것으로 간주됩니다
§ page.team.total.moneyAll.title: .
§ page.team.total.moneyAll.description: 포의 총 비용
§ page.team.total.moneyWorked.title: 실제
§ page.team.total.moneyWorked.description: 실제 일 평균 포를 곱한 일
§ page.team.total.moneyLosses.title: 가능한 초과 지불
§ page.team.total.moneyLosses.description: 커밋이 없는 유료 근무일
§ page.team.total.weekendPayment.title: 주말에 일
§ page.team.total.weekendPayment.description: 주말 작업에 대한 총 초과 지불
§ page.team.total.workSpeed.title: 일일 작업
§ page.team.total.workSpeed.description: 현재 직원과 팀의 평균 속도
§ page.team.total.moneySpeed.title: 달 당
§ page.team.total.moneySpeed.description: 세금 및 관련 비용을 제외한 현재 직원과 포에 대한 지불의 예상 금액
§ page.team.total.description1: *남자 일*은 한 근무일 동안 한 직원의 작업입니다. 예를 들어,한 달력 날,3 명의 직원으로 구성된 팀은 3 일 동안 많은 양의 일을 합니다.
§ page.team.total.description2: *결근 일*은 커밋을 할 수 있었던 영업일 만 간주됩니다. 주말,공휴일 및 휴가는 계산에 포함되지 않습니다.
§ page.team.total.description3: 카드*작동 및 종료*는 작업에 지속적으로 참여하는 직원의 실제 구성을 보여줍니다. 또한"조수"가 있습니다.이 직원은 일반적으로 다른 전문 분야의 직원이며 때로는 프로젝트에 커밋을 할 수 있습니다.
§ page.team.total.description4: *초과 지불*커밋이 이루어질 수 있었던 영업일만 계산합니다. 주말,공휴일 및 휴가는 계산에 포함되지 않습니다. 그 이유는 초과 지불+실제 비용!=장군 총 비용에는 주말,공휴일 및 휴가에 대한 지불이 포함됩니다.
§ page.team.total.description5: *주말 작업*은 정규 일의 지불에서 계수 2 배에 의해 계산됩니다. 이 맥락에서 처리 사실 자체가 흥미롭지 않기 때문에 위에 표시된 것은 초과 지불(1 배)입니다. 우리는 예산 연소 속도를 보지 않습니다. 우리는 작업 속도를 높일 때 초과 지불을 찾고 있습니다.
§ page.team.tree.title: 선택한 필터를 고려하여 프로젝트 트리
§ page.team.tree.filters.author: 직원
§ page.team.tree.filters.commits: 커밋 수
§ page.team.tree.filters.help: 직원이 파일에서 수행한 최소 커밋 수입니다
§ page.team.tree.filters.all: 모든 직원
§ page.team.tree.totalLines: 라인
§ page.team.tree.totalTasks: 작업
§ page.team.tree.totalDays: 일
§ page.team.tree.tasks: 작업
§ page.team.tree.days: 일
§ page.team.tree.add: 누가 추가 했습니까
§ page.team.tree.change: 누가 그것을 변경
§ page.team.tree.remove: 누가 그것을 삭제 했습니까
§ page.team.tree.line: 라인
§ page.team.tree.linesAdded: 추가
§ page.team.tree.linesChanged: 변경
§ page.team.tree.linesRemoved: 삭제
§ page.team.company.title: 세부 정보
§ page.team.company.employments.title: 숫자로
§ page.team.company.employments.item: 직원의
§ page.team.company.daysChart.title: 기간에 따라
§ page.team.company.daysChart.item: 회사의 계약
§ page.team.company.active.yes: ,
§ page.team.company.active.no: 계약이 만료되었습니다.
§ page.team.country.byTimezone: 마지막 커밋 시간까지
§ page.team.country.filters.active: 그들은 작동
§ page.team.country.filters.dismissed: 해고
§ page.team.country.filters.staff: 보조원
§ page.team.country.pieByDomain.title: 우편,시간 및 언어로
§ page.team.country.pieByTimezone.title: 에 의해
§ page.team.country.chart.item: 직원 시간
§ page.team.country.table.title: 직원 목록
§ page.team.country.table.country: 위치
§ page.team.country.table.employments: 직원
§ page.team.country.travel.title: 비즈니스 여행(또는 리베이스)
§ page.team.country.travel.author: 직원
§ page.team.country.travel.fly: 항공편 수
§ page.team.country.travel.path: 위치 목록
§ page.team.country.travel.date: 비행 날짜
§ page.team.country.travel.country: 위치
§ page.team.refactor.title: 리팩토링 후보
§ page.team.refactor.lines: § page.team.refactor.lines: строк
§ page.team.refactor.tasks: 작업 라인
§ page.team.refactor.days: 일
§ page.team.refactor.path: 방법
§ page.team.refactor.firstCommit: 첫 번째 커밋
§ page.team.refactor.totalLines: 라인
§ page.team.refactor.totalTasks: 작업
§ page.team.refactor.totalDays: 개발 일
§ page.team.day.commits: 커밋
§ page.team.day.activity: 활동
§ page.team.week.title: 주별 통계
§ page.team.week.date: 날짜
§ page.team.week.numberTasks: 작업 수
§ page.team.week.people: 사람 수
§ page.team.week.line: 라인 변경
§ page.team.week.days: 커밋이 있는 날과 없는 날
§ page.team.week.lossesDetails: 커밋하지 않은 사람
§ page.team.week.add: 추가
§ page.team.week.change: 변경
§ page.team.week.remove: 삭제
§ page.team.week.hasCommits: 커밋이 있었다
§ page.team.week.hasNotCommits: ,커밋이 없었습니다
§ page.team.week.days: 일
§ page.team.week.tasks: 작업
§ page.team.pr.task: 작업
§ page.team.pr.tasks: 작업
§ page.team.pr.firstCommitTime: 첫 번째 커밋
§ page.team.pr.lastCommitTime: 마지막
§ page.team.pr.workDays: 작업 작업에 소요된 평균 시간
§ page.team.pr.delayDays: 평균 홍보 검토 시간
§ page.team.pr.all.workDays: 작업 작업에 소요된 시간
§ page.team.pr.all.delayDays: 홍보 검토 시간
§ page.team.pr.middleTimeRelease: 검토 할 개발 시간의 비율
§ page.team.pr.chart.1day: 시간은 하루
§ page.team.pr.chart.3day: 3 일
§ page.team.pr.chart.7day: 한 주
§ page.team.pr.chart.14day: 2 주
§ page.team.pr.chart.30day: 한 달
§ page.team.pr.chart.more: 더 보기
§ page.team.pr.date: 주입 날짜
§ page.team.pr.mergeAuthor: 나는 그것을 부어
§ page.team.pr.author: 직원
§ page.team.pr.work: 개발
§ page.team.pr.delay: 대기 중
§ page.team.pr.days: 일
§ page.team.pr.oneTaskDays: 한 작업에 소요 된 시간
§ page.team.pr.description1: *개발 시간*이 작업은 작업의 첫 번째 커밋에서 마지막 커밋까지의 시간 차이입니다. 커밋 사이에 며칠의 휴식 시간이 있었는지 여부는 중요하지 않습니다. 모든 커밋의 바로 그 사실은 시간을 증가시킵니다.
§ page.team.pr.description2: *대기 시간*마지막 커밋과 코드 주입 사이의 시간입니다. 그것은 무언가를 기다리는 실제 유휴 상태를 보여줍니다.
§ page.team.pr.description3: *개발 시간을 표시하는 이유*코딩 및 코드 검토로 분해하지 않고? 그런 다음,비즈니스 코드의 실제 배달 시간을 표시합니다. 테스트의 기대,검토에 대한 의견,개발 운영 문제 및 프로세스의 다른 결함은 이미이 기간에 규정되어있다.
§ page.team.pr.statByAuthors: 직원 통계
§ page.team.pr.longDelay: 주입에 대한 긴 대기
§ page.team.pr.anonymous: 문제 번호가없는 홍보
§ page.team.pr.branch: 지점
§ page.team.tasks.task: 작업
§ page.team.tasks.author: 첫 번째 커밋의 저자
§ page.team.tasks.from: 첫 번째 커밋
§ page.team.tasks.to: 마지막 커밋
§ page.team.tasks.daysInWork: 일 의 날
§ page.team.tasks.comments: 댓글
§ page.team.extension.extension: 파일 확장자
§ page.team.extension.type: 파일 하위 유형
§ page.team.extension.name: 유형
§ page.team.extension.path: 경로
§ page.team.extension.current.count: 수량
§ page.team.extension.removed.count: 삭제된 수
§ page.team.extension.files: 파일
§ page.team.release.download: 다운로드
§ page.team.release.title: 릴리스
§ page.team.release.from: 생성 날짜
§ page.team.release.to: 완료 날짜
§ page.team.release.prLength: 작업
§ page.team.release.delay: 작업 일
§ page.team.release.waiting: 다음 릴리스 며칠 전
§ page.person.print.photo.title: 사진
§ page.person.print.photo.description: 사진 촬영 장소
§ page.person.total.title: 주요 특징
§ page.person.total.daysWorked.title: 작업 일의
§ page.person.total.daysWorked.description: 만 커밋하는 일
§ page.person.total.tasks.title: 고려되었다
§ page.person.total.tasks.description: 커밋이 올바르게 서명 된 경우
§ page.person.scoring.toolbar: 이 메트릭에 따른 위치,다른 메트릭에 대한 상대. 값이 동일한 경우 두 명의 직원이 한 자리를 차지할 수 있습니다. 따라서 총 장소 수는 직원 수보다 적을 수 있습니다.
§ page.person.character.title: 캐릭터
§ page.person.achievement.title: 진행
§ page.person.achievement.positive: 긍정적 인
§ page.person.achievement.normal: 중립
§ page.person.achievement.negative: 부정
§ page.person.achievement.description: 직원이 더 많은 부정적인 업적을 달성할수록 상황이 비표준일 가능성이 높아집니다. 작동 모드,작업 또는보고 모드를 변경할 가치가 있습니다. 당신은 그에게 이야기하고 그의 일을 방해하는 문제가 무엇인지 알아 내야합니다.
§ page.person.gets.title: 작업 번호 메달:
§ page.person.gets.description: 메달은 사용자가"아름다운"번호로 작업에 대한 약속을 가장 먼저 남기면 수여됩니다.
§ page.person.business.days.title: 작업 일
§ page.person.business.days.description: 만 커밋하는 일
§ page.person.business.tasks.title: 고려되었다
§ page.person.business.tasks.description: 커밋이 올바르게 서명 된 경우
§ page.person.business.losses.title: ,커밋이없는 일
§ page.person.business.losses.description: 모든 일 빼기:휴일,주말,휴가,커밋 일
§ page.person.business.commits.title: 커밋
§ page.person.business.commits.description: 삭제된 분기는 포함되지 않습니다
§ page.person.business.time.description: 첫 번째 커밋부터 마지막 커밋까지의 시간(비 작업 일 포함)
§ page.person.business.time.title: 프로젝트 일:
§ page.person.business.time.dismissed: (해고)
§ page.person.business.time.staff: (조수)
§ page.person.business.achievements: 업적
§ page.person.changes.title: 진행
§ page.person.changes.description:
일부 유형의 서식을 사용하면 문자열을"삭제됨"및"추가됨"으로 표시합니다.,
사실 그들은"변경"되었습니다. 따라서 리팩토링을 많이 한 경우,
힘내는 통계의 변화의 작은 숫자,실제 결과를 표시 할 수 있습니다
"삭제됨"및"추가됨"행의 점프로 표시됩니다.
§ page.person.changes.description: 그 날의 커밋 목록과 변경 횟수:
§ page.person.commits.title: 커밋 목록:
§ page.person.money.title.total: 모든 시간 동안
§ page.person.money.title.middle: 평균 비용
§ page.person.money.moneyAll.title: 수신
§ page.person.money.moneyAll.description: 프로젝트에서 포의 예상 금액(설정 참조)
§ page.person.money.moneyWorked.title: 밖으로 일
§ page.person.money.moneyWorked.description: 실제 일 평균 포를 곱한 일
§ page.person.money.moneyLosses.title: 가능한 초과 지불
§ page.person.money.moneyLosses.description: 커밋이 없는 일에 평균 포를 곱한 값
§ page.person.money.tasks.title: 작업
§ page.person.money.tasks.description: 비용에 대한 닫힌 작업 수
§ page.person.money.commits.title: 약속의 날
§ page.person.money.commits.description: 작업 일 비용에 대한 커밋 수
§ page.person.speed.task: 평균적으로 한 가지 과제는
§ page.person.speed.max: 하루 최대 속도
§ page.person.speed.days.title: 일
§ page.person.speed.days.description: 이는 커밋이 올바르게 서명 된 경우 작업 일을 의미합니다.
§ page.person.speed.commits.title: 커밋
§ page.person.speed.commits.description: 최대 및 최소값의 10%
§ page.person.speed.line.title: 코드 라인이 차단되었습니다
§ page.person.speed.line.description: 최대 및 최소의 10%
§ page.person.speed.tasks.title: 작업 값이 차단되었습니다
§ page.person.speed.tasks.description: 작업이 완료되지 않을 수 있지만 작업이 완료되어야 합니다
§ page.person.speed.maxCommits.title: 커밋
§ page.person.speed.maxCommits.description: 작업이 완료되지 않을 수 있지만 작업이 완료되어야 합니다
§ page.person.hours.title: 각 요일 동안의 커밋 배포
§ page.person.week.date: 날짜
§ page.person.week.tasks: 작업 수
§ page.person.week.workDays: 커밋이 있는 일
§ page.person.week.taskInDay: 일일 작업
§ page.person.week.days: 일
§ page.person.week.workDay: 평일
§ page.person.week.weekends: 주말
§ page.sponsor.title: 프로젝트 지원
§ page.sponsor.share.description: 소셜 네트워크에서 우리의[프로젝트|<url>/바키레프/아사요]에 대해 알려주세요! 이 응용 프로그램은 당신이 당신의 마음에 드는 사진을 공유 할 수 있습니다,당신은 당신의 마음에 드는 사진에 텍스트를 추가 할 수 있습니다,당신은 당신의 마음에 드는 사진에 텍스트를 추가 할 수 있습니다,당신은 당신의 마음에 드는 사진에 텍스트를 추가 할 수 있습니다,당신은 당신의 마음에 드는 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은 사진에 텍스트를 추가 할 수 있습니다,당신은
§ page.sponsor.share.button: 링크 복사
§ page.sponsor.money.description: 당신이 어떤 금액으로 우리를 지원하는 경우 우리는 기쁠 것이다! 모든 자금은 프로젝트의 추가 개발에 사용될 것입니다.
§ page.sponsor.money.qr: 1 회 결제
§ page.sponsor.money.github: 깃 허브 스폰서 구독
`;
